module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offline-wrapper"
  }, [_c('div', {
    staticClass: "offline-inner"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  })]), _vm._v(" "), _c('h1', [_vm._v("Whoops!")]), _vm._v(" "), _c('h3', [_vm._v("You've lost the connection to the internet.")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("We could not register a live connection to the internet. Since this application uses network functions, please make sure you have a valid network connection and try again.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Refresh this page")])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-87b029dc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87b029dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/offline.vue
// module id = 868
// module chunks = 0